import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider, connect } from "react-redux";
import { Store, Dispatch, bindActionCreators } from "redux";
import { Action, isType, actionCreatorFactory } from "diy/redux/typedActions";
const actionCreator = actionCreatorFactory('diy/ModuleActionBar/');
import StoreProvider from "diy/redux/StoreProvider";

import ModuleActionBar from "./components/ModuleActionBar";
import {AppState} from "diy/redux/app/state";
import NotificationApi from "diy/toolbar/notificationNG/Api";

// =====
// STATE
// =====
export interface ModuleActionBarState {
    isOpen: boolean;
    undoEnabled: boolean;
    redoEnabled: boolean;
    currentTab: number;
    moduleId?: number;
}

const initialState: ModuleActionBarState = {
    isOpen: false,
    undoEnabled: false,
    redoEnabled: false,
    currentTab: 0
};

// ===============
// ACTION CREATORS
// ===============
type OpenPayload  = {
    moduleId: number;
};
export const open = actionCreator<OpenPayload>('OPEN');
export const close = actionCreator<void>('CLOSE');
type EnabledPayload  = {
    enabled: boolean;
};
export const setUndoState = actionCreator<EnabledPayload>('SET_UNDO_STATE');
export const setRedoState = actionCreator<EnabledPayload>('SET_REDO_STATE');
type CurrentTabPayload = {
    nextTab: number;
    currentTabWhitelist?: number[];
};
export const setCurrentTab = actionCreator<CurrentTabPayload>('SET_CURRENT_TAB');

// =======
// REDUCER
// =======
function reducer(
    state: ModuleActionBarState = initialState,
    action: Action<any>
): ModuleActionBarState {

    if (isType(action, open)) {
        return Object.assign({}, state, {
            isOpen: true,
            moduleId: action.payload.moduleId,
            currentTab: 0
        });
    }

    if (isType(action, close)) {
        return Object.assign({}, state, {
            isOpen: false,
            moduleId: null,
            undoEnabled: false,
            redoEnabled: false
        });
    }

    if (isType(action, setUndoState)) {
        return Object.assign({}, state, {
            undoEnabled: action.payload.enabled
        });
    }

    if (isType(action, setRedoState)) {
        return Object.assign({}, state, {
            redoEnabled: action.payload.enabled
        });
    }

    if (isType(action, setCurrentTab)) {
        if (
            !action.payload.currentTabWhitelist
            || action.payload.currentTabWhitelist.indexOf(state.currentTab) !== -1
        ) {
            return Object.assign({}, state, {
                currentTab: action.payload.nextTab
            });
        }
    }

    return state;
}

// ======================
// CONNECT REACT TO REDUX
// ======================
function mapStateToProps(state: AppState) {
    const ownState = state.moduleActionBar;
    return {
        open: ownState.isOpen,
        moduleId: ownState.moduleId,
        undoEnabled: ownState.undoEnabled,
        redoEnabled: ownState.redoEnabled,
        currentTab: ownState.currentTab
    };
};

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        onTabChange: setCurrentTab
    }, dispatch);
}

function render(store: Store) {
    let actionBarContainer = document.createElement('div');
    actionBarContainer.setAttribute('id', 'diy-action-bar');
    document.body.appendChild(actionBarContainer);

    const ConnectedActionBar = connect(mapStateToProps, mapDispatchToProps)(ModuleActionBar);

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedActionBar/>
        </Provider>,
        actionBarContainer
    );
}

function watchStore(store: Store) {
    let oldActionBarOpen = false;
    store.subscribe(() => {
        let state = store.getState() as AppState;
        if (state.moduleActionBar.isOpen !== oldActionBarOpen) {
            oldActionBarOpen = state.moduleActionBar.isOpen;

            if (state.moduleActionBar.isOpen) {
                NotificationApi.schedule(() => {
                    NotificationApi.pause();
                });
            } else {
                NotificationApi.schedule(() => {
                    NotificationApi.resume();
                });
            }
        }
    });
}

// ==============
// INITIALIZATION
// ==============
let initialized = false;
export function init(storeProvider: StoreProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, "moduleActionBar");
        render(storeProvider.getStore());
        watchStore(storeProvider.getStore());
        initialized = true;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module-action-bar/index.tsx
 **/